import React, {Fragment, memo, useCallback} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {createSelector} from 'reselect';

import {reduceLayersToLegends, visibleLayersWithLegendsSelector} from '@mapsight/core/lib/map/selectors';
import {viewSelector} from '@mapsight/ui/src/js/store/selectors';
import {setOverlayModalVisible} from '@mapsight/ui/src/js/store/actions';

import {MAP} from '@mapsight/ui/src/js/config/constants/controllers';

import Attribution from '@mapsight/ui/src/js/components/map-overlay/attribution';

import {withErrorBoundary} from '../../modules/error-boundary';
import {memoForever} from '../../modules/helpers';

import {isViewWithMapWidget} from '../store/selectors';
import {useNavPos} from '../../hooks';

import NaviWidget from '../../stade/components/navi-widget';
import PoiCycling from '../../stade/components/poi-cycling';


const legendsSelector = createSelector(
	state => visibleLayersWithLegendsSelector(state[MAP]),
	// we need to run this as well, cause it's filtering stuff
	reduceLayersToLegends,
);


/** @type {import("@mapsight/ui/src/js/components/contexts").MapOverlayEnd} */
const MapOverlayEnd = withErrorBoundary(memo(function MapOverlayEnd({}) {
		const navPos = useNavPos();
		const view = useSelector(viewSelector);
		const mapInWidget = isViewWithMapWidget(view);

		const legends = useSelector(legendsSelector);
		const dispatch=useDispatch();
		const expand = useCallback(
			() => {
				dispatch(setOverlayModalVisible(true));
			},
			[dispatch],
		);

		const attributionContent = (!mapInWidget) ? (
			<Attribution
				additional={Object.keys(legends).length !== 0 && (
					<button
						type="button"
						onClick={expand}
					>
						{/* TODO: translate? nicht für Sta-de weil hier keine Legende verwendet wird */}
						Legende
					</button>
				)}
			/>
		) : (
			<div className="ms3-attribution">
				<ul className="ms3-attribution__entries">
					<li className="ms3-attribution__entry">{
						navPos?.app?.lang === 'en' ?
						'Map: © OpenStreetMap contributors' :
						'Karte: © OpenStreetMap-Mitwirkende'
					}</li>
				</ul>
			</div>
		);

		return (<Fragment>
			<div className={`stade-map-overlay-end ${mapInWidget ? 'stade-map-overlay-end__widget' : ''}`}>
				{attributionContent}
			</div>
			{(!mapInWidget) && <Fragment>
				<PoiCycling />
				<NaviWidget />
			</Fragment>}
		</Fragment>);
	},
	memoForever
));
export default MapOverlayEnd;
